import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  select(event) {
    const regionCode = event.currentTarget.dataset.region
    // Set region via URL param which will be stored in session
    const url = new URL(window.location.href)
    url.searchParams.set("region", regionCode)
    window.Turbo.visit(url.toString())
  }

  clear() {
    const url = new URL(window.location.href)
    url.searchParams.delete("region")
    window.Turbo.visit(url.toString())
  }
}
